// extracted by mini-css-extract-plugin
export default {"container":"tooltip_container__WZ5st","tooltip":"tooltip_tooltip__WTK5+"};